import { Outlet } from "react-router-dom";
import WagonForm from "./WagonForm";
import WagonList from "./WagonList";

export const adminWagonsRoutes = [
  {
    path: "wagons",
    element: Outlet,
    children: [
      {
        path: "",
        element: WagonList,
      },
      {
        path: "list",
        element: WagonList,
      },
      {
        path: "add",
        element: WagonForm,
      },
      {
        path: "edit/:id",
        element: WagonForm,
      },
    ],
  },
];
